/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
import moment from 'moment';
import helper from '@/_libs/helper';

// for MOCK
import _customer from '../cs/_customer';

const { 
  ORDER_STATUS,
  SHIPMENT_STATUS,
  // BACK_ORDER_STATUS,
  CUSTOMERS,
  SELLERS,
} = _customer;

const DATE_TODAY = moment().format('YYYY-MM-DD');

// const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
// const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
// const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const CURRENT_TIME = new Date().getTime();

// const COL_TYPE = {
//   PermissionLevels: 100,
//   ActivationStatus: 101,
//   LoginUrl: 102,
// };

// const PERMISSION_LEVELS = {
//   SALE: 0,
//   CS: 1,
//   ADMIN: 2,
// };

const MOCK = {
  pendingApproval: {
    list: [
      {
        entryNo: '20/567',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 69990,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[0],
        seller: SELLERS[0],
        weight: 12,
    
        updated: true,
      },
      {
        entryNo: '20/569',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 69990,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[0],
        seller: SELLERS[0],
        weight: 10,
    
        updated: true,
      },
      {
        entryNo: '20/568',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 55555,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[1],
        seller: SELLERS[1],
        weight: 6,
      },
      {
        entryNo: '20/609',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 12345,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[1],
        seller: SELLERS[2],
        weight: 2,
    
        updated: true,
      },
      {
        entryNo: '20/519',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 76739,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[2],
        seller: SELLERS[3],
        weight: 4,
      },
    ],
  },
};

const pendingApproval = {
  // Permission
  async list() {
    return await helper.call('admin.pendingApproval.list', {
      success: true,
      data: MOCK.pendingApproval.list,
    }, async () => await axios(helper.path('admin/pendingApproval/list')));
  },

  // PERMISSION_LEVELS,
  // COL_TYPE,
};

export default pendingApproval;
